export const ActionTypes = {
  FETCH_UNIDENTIFIED_OPERATORS_OPERATION:
    'services/unidentifiedOperatorsOperation/fetch_unidentified_operators_operation',
  SET_UNIDENTIFIED_OPERATORS_OPERATION: 'services/unidentifiedOperatorsOperation/set_unidentified_operators_operation',
  SET_UNIDENTIFIED_OPERATORS_OPERATION_LOADER_STATUS:
    'services/unidentifiedOperatorsOperation/set_unidentified_operators_operation_loader_status',
  UPDATE_UNIDENTIFIED_OPERATORS_OPERATION:
    'services/unidentifiedOperatorsOperation/update_unidentified_operators_operation',
  FETCH_TRACKER_EXIST_OPERATION: 'services/unidentifiedOperatorsOperation/fetch_tracker_exist_operation',
  SET_TRACKER_EXIST_OPERATION: 'services/unidentifiedOperatorsOperation/set_tracker_exist_operation',
  SET_TRACKER_EXIST_OPERATION_LOADER_STATUS:
    'services/unidentifiedOperatorsOperation/set_tracker_exist_operation_loader_status',

  FETCH_OPERATOR_BY_ID: 'services/unidentifiedOperatorsOperation/fetch_operator_by_id',
  SET_OPERATOR_BY_ID: 'services/unidentifiedOperatorsOperation/set_operator_by_id',
  SET_OPERATOR_BY_ID_LOADER_STATUS: 'services/unidentifiedOperatorsOperation/set_operator_by_id_loader_status',
};

const fetchUnidentifiedOperatorsOperation = ({ unidentifiedOperatorsOperationParams }) => ({
  unidentifiedOperatorsOperationParams,
  type: ActionTypes.FETCH_UNIDENTIFIED_OPERATORS_OPERATION,
});

const setUnidentifiedOperatorsOperation = ({ unidentifiedOperatorsData }) => ({
  unidentifiedOperatorsData,
  type: ActionTypes.SET_UNIDENTIFIED_OPERATORS_OPERATION,
});

const setUnidentifiedOperatorsOperationLoaderStatus = ({ unidentifiedOperatorsOperationLoader }) => ({
  unidentifiedOperatorsOperationLoader,
  type: ActionTypes.SET_UNIDENTIFIED_OPERATORS_OPERATION_LOADER_STATUS,
});

const updateUnidentifiedOperator = ({ unidentifiedOperatorsObj, unidentifiedOperatorsOperationParams }) => ({
  unidentifiedOperatorsObj,
  unidentifiedOperatorsOperationParams,
  type: ActionTypes.UPDATE_UNIDENTIFIED_OPERATORS_OPERATION,
});

const trackerExist = ({ trackerId }) => ({
  trackerId,
  type: ActionTypes.FETCH_TRACKER_EXIST_OPERATION,
});

const setTrackerExist = ({ trackerExistsData }) => ({
  trackerExistsData,
  type: ActionTypes.SET_TRACKER_EXIST_OPERATION,
});

const setTrackerExistLoaderStatus = ({ trackerExistLoader }) => ({
  trackerExistLoader,
  type: ActionTypes.SET_TRACKER_EXIST_OPERATION_LOADER_STATUS,
});

const fetchOperatorById = ({ operatorId }) => ({
  operatorId,
  type: ActionTypes.FETCH_OPERATOR_BY_ID,
});

const setOperatorById = ({ operatorData }) => ({
  operatorData,
  type: ActionTypes.SET_OPERATOR_BY_ID,
});

const setOperatorByIdLoaderStatus = ({ operatorByIdLoader }) => ({
  operatorByIdLoader,
  type: ActionTypes.SET_OPERATOR_BY_ID_LOADER_STATUS,
});

export default {
  fetchUnidentifiedOperatorsOperation,
  setUnidentifiedOperatorsOperation,
  setUnidentifiedOperatorsOperationLoaderStatus,
  updateUnidentifiedOperator,
  trackerExist,
  setTrackerExist,
  setTrackerExistLoaderStatus,
  fetchOperatorById,
  setOperatorById,
  setOperatorByIdLoaderStatus,
};
